
export class ModelState<T>{
  Model:T;
  IsFakeData:boolean;
  IsNewData:boolean;

  constructor(model:T , isFakeData:boolean=false, isNewData:boolean = false) {
    this.Model = model;
    this.IsFakeData = isFakeData;
    this.IsNewData = isNewData;
  }

}
